"use strict";
function Show(props) {
  const { when, fallback, children } = props;
  if (!when) {
    return fallback || null;
  }
  return typeof children === "function" ? children(when) : children;
}

export { Show };
